import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=0442f4a3&"
import script from "./CancelPolicy.vue?vue&type=script&lang=js&"
export * from "./CancelPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CancelPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CancelPolicy.vue"
export default component.exports